import { theme } from '../../../../Assets/Styles/theme'

const styles = {
  profilePicture: {
    maxWidth: '120px',
    display: 'block',
  },
  box: { display: 'flex', flexDirection: 'column' },
  label: {
    color: `${theme.colors.regentGray}`,
  },
  description: {
    color: '#546b81',
  },
}

export default styles
